import { z } from 'zod';
import { CustomerDataSchema } from '../customer';
import { PaymentMethodDataSchema } from '../customer/payment-methods';
import { MobileServiceSchema_BD } from '../mobile-services';
import { ProductDataSchema, ProductTypeSchema } from '../products';
import { SaleItemMetadataSchema } from '../sale';
import { ActionStatusSchema, PaymentMethodSchema, SourceStatusSchema, } from '../status';
import { ZodStringToDate } from '../system';
import { ProcessingConfigSchema } from '../user/web';
export const FinancialPaymentTransactionSchema = z.object({
    id: z.string(),
    type: PaymentMethodSchema,
    amount: z.number(),
    merchantNetAmount: z.number(),
    refundedAmount: z.number().optional(),
    date: ZodStringToDate,
    status: ActionStatusSchema,
    paymentMethod: PaymentMethodDataSchema.optional(),
    // v4 checkout fields — accurate status + refund grouping. All optional; null/
    // absent on legacy (pre-v4) rows. Typed as plain strings (compare against the
    // PaymentStatusV4 / PaymentTransactionTypeV4 enums) to avoid a checkout ↔
    // sale/v4 import cycle.
    statusV4: z.string().nullable().optional(),
    transactionType: z.string().optional(), // 'PAYMENT' | 'REFUND'
    parentTransactionId: z.string().nullable().optional(),
});
export const FinancialDataSchema = z.object({
    total: z.number(),
    cost: z.number(),
    subTotal: z.number(),
    balanceDue: z.number(),
    payment: z.object({
        cash: z.number(),
        card: z.number(),
        ebt: z.number(),
        totalAmount: z.number(),
        transactions: z.array(FinancialPaymentTransactionSchema),
    }),
    processingFees: z.number(),
    merchantProcessingFees: z.number(),
    shippingCharges: z.number(),
    adjustment: z.number(),
    taxes: z.number(),
    tip: z.number().optional(),
    discount: z.number(),
    copyOfProcessingConfig: ProcessingConfigSchema,
});
// ______________________________________________________
// Single Sale Transaction
export const CompletedPaymentTransactionSchema = FinancialPaymentTransactionSchema.extend({
    last4CardNumber: z.string(),
    cardType: z.string(),
});
export const SingleSaleSchema = z.object({
    id: z.string(),
    shortIdentifier: z.string(),
    taxes: z.number(),
    discount: z.number(),
    subTotal: z.number(),
    processingFees: z.number(),
    balance: z.number(),
    total: z.number(),
    createdAt: ZodStringToDate,
    status: SourceStatusSchema,
    items: z.array(z.object({
        id: z.string(),
        identifier: z.string(),
        name: z.string(),
        price: z.number(),
        cost: z.number(),
        quantity: z.number(),
        linkedProduct: ProductDataSchema.nullable(),
        linkedMobileService: MobileServiceSchema_BD.nullable(),
        productType: ProductTypeSchema.nullable(),
        metadata: SaleItemMetadataSchema,
    })),
    payments: z.array(CompletedPaymentTransactionSchema),
    customer: CustomerDataSchema.nullable(),
});
